module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("By")]), _vm._v(" C"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("AITLIN")]), _vm._v(" R"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("ICCI")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Country Strong")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Cuddling (Dreamspinner Anthology)")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("His Lion Tamer")])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Marked by Grief")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("A F")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("OREVER")]), _vm._v(" "), _c('span', {
    staticClass: "t10"
  }, [_vm._v("H")]), _c('span', {
    staticClass: "t11"
  }, [_vm._v("OME")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Rescuing Jack")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Of Monsters and Men")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t13"
  }, [_vm._v("Published by Harmony Ink Press")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("First Time for Everything (Harmony Ink Anthology)")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Weathering the Storm")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("Published by")]), _vm._v(" D"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("REAMSPINNER")]), _vm._v(" P"), _c('span', {
    staticClass: "t9"
  }, [_vm._v("RESS")])]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_c('span', {
    staticClass: "t7"
  }, [_vm._v("http://www.dreamspinnerpress.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47a756e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/003.vue
// module id = 60
// module chunks = 0